var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileServices2 = function SvgCategoryMobileServices2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_services2_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_services2_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_services2_svg__st0",
    d: "m31.2 20.8-13.4.1c-.6 0-1.2-.5-1.2-1.2v-2.8c0-.6.5-1.2 1.2-1.2h13.3c.6 0 1.2.5 1.2 1.2v2.8c.1.5-.4 1.1-1.1 1.1zM22.5 32.8v-4.7c0-.4.3-.7.7-.7h1.2c.4 0 .7.3.7.7v4.7c0 .4-.3.7-.7.7h-1.1c-.4 0-.8-.3-.8-.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_services2_svg__st0",
    d: "M31.9 18.2H34.2c.5.1 1 .6 1 1.1v.8c0 .6-.3 1.3-.8 1.6-.3.3-.7.5-1.2.6L25.3 24c-.7.2-1.2.9-1.2 1.7v1.7"
  })));
};
export default SvgCategoryMobileServices2;